import React from "react";
import point from "./../../../../Images/point.png";

const BridalMakeupInUptownWhat = () => {
  return (
    <div className="hairsalonInUptownWhyChoose">
      <h5>What to Expect from SCENT’s Bridal Makeup in Uptown Whitefield</h5>
      <p>
        At SCENT, our{" "}
        <a href="https://scentlifestyle.com/bridal-makeup">
          Bridal Makeup in Uptown Whitefield
        </a>{" "}
        services are designed to give you a flawless look that will last
        throughout your wedding day. Here’s what you can expect when you book
        your bridal makeup appointment with us:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Personalized Consultation:{" "}
          </span>
          <p>
            Your journey to the perfect bridal makeup look begins with a
            detailed consultation. During this session, our makeup artists will
            discuss your preferences, the wedding theme, your dress, and any
            special requests you may have. We believe that communication is key
            to creating a look that you’ll love, so we encourage you to share
            your ideas and inspirations.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Trial Makeup:{" "}
          </span>
          <p>
            We offer trial makeup sessions as part of our{" "}
            <a href="https://scentlifestyle.com/bridal-makeup">
              Bridal Makeup in Uptown Whitefield
            </a>{" "}
            services. A trial run allows us to experiment with different looks,
            ensuring that you’re 100% satisfied with the final result. This
            trial session is a great way to get a preview of your wedding day
            makeup and make any adjustments necessary to achieve the desired
            outcome.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Perfect Eye Makeup:{" "}
          </span>
          <p>
            Your eyes are one of the most important features on your wedding
            day, as they’ll be a focal point in your photos. SCENT’s{" "}
            <a href="https://scentlifestyle.com/bridal-makeup">
              Bridal Makeup in Uptown Whitefield
            </a>{" "}
            services include expertly applied eye makeup tailored to your
            preferences. Whether you want soft, romantic eyes or a bold, smoky
            look, our makeup artists will use premium eyeshadows, liners, and
            lashes to enhance your eye shape and color.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Pre-Bridal Skin Care:{" "}
          </span>
          <p>
            Contouring and highlighting help to define and accentuate your
            facial features. Our makeup artists use professional techniques to
            sculpt your face, making your cheekbones, jawline, and nose appear
            more defined. Highlighting adds a touch of radiance to your overall
            look, giving you a healthy glow that looks stunning in photographs.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Long-Lasting Lip Color:{" "}
          </span>
          <p>
            Your lip color should complement your overall bridal look while also
            lasting throughout the day. SCENT’s{" "}
            <a href="https://scentlifestyle.com/bridal-makeup-packages">
              Bridal Makeup in Uptown Whitefield
            </a>{" "}
            includes selecting the perfect lipstick shade for you—whether it’s a
            bold red, soft pink, or a nude hue. We use long-lasting,
            transfer-proof lipsticks to ensure your lips stay beautiful through
            kisses, sips of champagne, and more.
          </p>
        </li>{" "}
      </ul>
    </div>
  );
};

export default BridalMakeupInUptownWhat;
